var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-5 px-5"},[_c('RecursiveILOsCheckbox',{attrs:{"items":Object.values(_vm.ilos)},on:{"ilo-checkbox-change":_vm.onChangeCheckBox}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }